import { useTranslation } from 'react-i18next'

import styles from './JournalGrid.module.scss'

const JournalGrid = ({
  students,
  lessons,
  statusList,
  activeCell,
  setActiveCell,
  getAtt,
  getMark,
  setAtt,
  setMarkVal,
  averageScore,
}) => {
  const { t } = useTranslation('common')

  return (
    <div className={`unv-card ${styles.tableWrap}`}>
      <table className={`unv-table ${styles.journal}`}>
        <thead>
          <tr>
            <th className={styles.studentCol}>{t('journal.student_col')}</th>
            {lessons.map((l) => (
              <th key={l.id} className={styles.lessonCol}>
                <div>
                  {l.date ||
                    (l.start_at ? new Date(l.start_at).toLocaleDateString('ru-RU') : '')}
                </div>
                <div className={styles.muted}>{l.subject_name || ''}</div>
              </th>
            ))}
            <th className={styles.avgCol}>{t('journal.avg_short')}</th>
          </tr>
        </thead>
        <tbody>
          {students.map((s) => (
            <tr key={s.id}>
              <td className={styles.studentCol}>{s.full_name || s.name || `#${s.id}`}</td>
              {lessons.map((l) => {
                const att = getAtt(l.id, s.id)
                const mark = getMark(l.id, s.id)
                const isActive =
                  activeCell?.lessonId === l.id && activeCell?.studentId === s.id
                return (
                  <td
                    key={l.id}
                    className={`${styles.cell} ${isActive ? styles.cellActive : ''}`}
                    onClick={() => setActiveCell({ lessonId: l.id, studentId: s.id })}
                  >
                    <div className={styles.cellRow}>
                      <select
                        className={styles.attSelect}
                        value={att || ''}
                        onChange={(e) => setAtt(l.id, s.id, e.target.value)}
                      >
                        <option value="">—</option>
                        {statusList.map((st) => (
                          <option key={st.key} value={st.key}>
                            {st.label}
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        min="1"
                        max="100"
                        className={styles.markInput}
                        value={mark}
                        onChange={(e) => setMarkVal(l.id, s.id, e.target.value)}
                      />
                    </div>
                  </td>
                )
              })}
              <td className={styles.avgCol}>
                <span className="unv-badge">{averageScore(s.id)}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default JournalGrid
